import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { qk } from "../../lib/queryKeys";
import { getJson } from "../../lib/http";
import { useCompaniesStore } from "../../store/admin/companiesStore";
import {
  useTruckYardStore,
  type TruckYardVehicle,
} from "../../store/truckYardStore";

interface VehicleListBody {
  data?: TruckYardVehicle[];
  meta?: { totalItems?: number };
}

const ALL_VEHICLES_LIMIT = 1000;

export function useAllTruckYardVehicles() {
  const companyId = useCompaniesStore((s) => s.companyId);

  const query = useQuery({
    queryKey: qk.vehicles.all(companyId),
    queryFn: ({ signal }) =>
      getJson<VehicleListBody>(
        "/vehicleList",
        { page: 1, limit: ALL_VEHICLES_LIMIT },
        { signal },
      ).then((body) => body.data ?? []),
    enabled: !!companyId,
    staleTime: 5 * 60_000,
  });

  useEffect(() => {
    if (query.data) {
      useTruckYardStore.setState({
        vehicles: query.data,
        totalVehicles: query.data.length,
      });
    }
  }, [query.data]);

  return query;
}
